<template>
    <div class="d-flex" id="wrapper"   >
       <!-- SIDEBAR -->
         <div class="bg-dark-ed border-right text-white"  id="sidebar-wrapper" >
             
            <div class="sidebar-heading font-rounded">
                <!-- <i class="fas fa-bars mt-1 mr-1"></i> -->
                <img alt="Vue logo" src="../../assets/logo-cambialefacile_200-36.png" height="30">
            </div>

            <NavMainOwn/>

            <div class="list-group list-group-flush   ">
            </div>
        </div>

        <!-- CONTENT (header + main content )-->
        <div class="bg-dark-ed  text-white" id="page-content-wrapper">
            <slot/>
        </div>

    </div>
</template>

<script>
  import NavMain from '../NavMain.vue'
  export default {
    name: 'LayoutWithSidebar', //this is the name of the component
    components: {
      NavMainOwn: NavMain,
    },
    data: function () {
      return {}
    },
    computed: {
      isSidebarOpened () {
      },
    },
    mounted () {
    }
  }
</script>

<style scoped>

    .bg-dark-ed {
        background-color: #222939 !important ;
    }
    /* .btn-dark {
        background-color: transparent !important;

        border-color: #343a40;
        border-color: white !important;
    } */
</style>
